/* EU Energy Label — popup toggle (vanilla JS, no dependencies) */
(function () {
  'use strict';

  function init(root) {
    var labels = (root || document).querySelectorAll('[data-el]');
    labels.forEach(function (el) {
      if (el._elInit) return;
      el._elInit = true;

      var btn = el.querySelector('.el__btn');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = el.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.el.is-open').forEach(function (el) {
      if (!el.contains(e.target)) {
        el.classList.remove('is-open');
        var btn = el.querySelector('.el__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.el.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var btn = el.querySelector('.el__btn');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Shopify section re-render (theme editor / AJAX carts) */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('cart:refresh', function (e) {
    if (e && e.target) init(e.target);
  });
})();